module.exports = __webpack_public_path__ + "img/popup_battery_3.50b45589.svg";